import { render, staticRenderFns } from "./LeadList.vue?vue&type=template&id=3c872e47&scoped=true&"
import script from "./LeadList.vue?vue&type=script&lang=js&"
export * from "./LeadList.vue?vue&type=script&lang=js&"
import style0 from "@/sass/08_modules/lead-list.scss?vue&type=style&index=0&id=3c872e47&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c872e47",
  null
  
)

export default component.exports